export * from './main.component';